import { ButtonDropDown, DropdownMenuItem, Tooltip } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../contentConstants';
import { ActionType, AudienceSourceType, ConditionSourceType } from '../../models';
import { BranchingLogicHelper } from '../../utilities';

export enum IDisabledReason {
	WrongAudienceSourceType = 'WrongAudienceSourceType',
	NoDistribution = 'NoDistribution',
}

export type DisabledReason = {
	disabled: boolean;
	reason?: IDisabledReason;
};

export interface IAddConditionsDropDownProps {
	disabled?: boolean;
	audienceSourceType?: AudienceSourceType;
	noAvailableDisplayLogicQuestions: boolean;
	attributeDisabled: DisabledReason;
	hierarchyDisabled: DisabledReason;
	actionType: ActionType;
	onConditionMenuItemClick: (conditionSourceType: ConditionSourceType) => void;
}

export const AddConditionsDropDown = ({
	disabled,
	audienceSourceType,
	noAvailableDisplayLogicQuestions,
	attributeDisabled,
	hierarchyDisabled,
	actionType,
	onConditionMenuItemClick,
}: IAddConditionsDropDownProps) => {
	const attributeSourceType = BranchingLogicHelper.getAttributeSourceType(audienceSourceType);

	const tooltipText = {
		[IDisabledReason.WrongAudienceSourceType]: ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_OTHER_SOURCE,
		[IDisabledReason.NoDistribution]: ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART1.concat(
			ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART2,
			ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART3,
		),
	};

	return (
		<ButtonDropDown disabled={disabled} buttonText={ContentConstants.BUTTONS_ADD_CONDITION} color='secondary'>
			<DropdownMenuItem
				disabled={noAvailableDisplayLogicQuestions}
				onClick={() => onConditionMenuItemClick(ConditionSourceType.PreviousQuestion)}
			>
				<span>
					{actionType !== ActionType.BranchToQuestion
						? ContentConstants.DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_PREVIOUS_QUESTION
						: ContentConstants.DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_THIS_OR_PREVIOUS_QUESTION}
				</span>
			</DropdownMenuItem>
			<DropdownMenuItem disabled={attributeDisabled.disabled} onClick={() => onConditionMenuItemClick(attributeSourceType)}>
				<span>
					{ContentConstants.DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_ATTRIBUTE}
					{attributeDisabled.disabled && attributeDisabled.reason && (
						<Tooltip id='select-attribute-disabled'>{tooltipText[attributeDisabled.reason]}</Tooltip>
					)}
				</span>
			</DropdownMenuItem>
			<DropdownMenuItem disabled={hierarchyDisabled.disabled} onClick={() => onConditionMenuItemClick(ConditionSourceType.HierarchyNode)}>
				<span>
					{ContentConstants.DISPLAY_LOGIC_MODAL_CONDITION_DROPDOWN_HIERARCHY}
					{hierarchyDisabled.disabled && hierarchyDisabled.reason && (
						<Tooltip id='select-hierarchy-disabled'>{tooltipText[hierarchyDisabled.reason]}</Tooltip>
					)}
				</span>
			</DropdownMenuItem>
		</ButtonDropDown>
	);
};
